// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6b5de920","732":"0c0b01bf","977":"616b7432"}[chunkId] + ".chunk.js";
};